<template>
  <div>
    <q-dialog :visible="isVisible" :title="title" width="550px" :innerScroll="false" :showFooter="false" @close="onCancel">
      <div v-loading="loading" element-loading-text="数据加载中">
        <el-form :model="requestParam"  ref="requestParam" label-width="100px">
          <el-form-item label="职员名称：">
            <span>{{textForm.realName}}</span>
          </el-form-item>
          <el-form-item label="职员手机号：">
            <span>{{textForm.telephone}}</span>
          </el-form-item>
        </el-form>
        <div style="text-align: center">
          <el-button @click="onCancel" size="medium">关 闭</el-button>
        </div>
      </div>
    </q-dialog>
  </div>
</template>

<script>
export default {
  name: "up",
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    rowData: Object,
    userId: [Number,String]
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    title() {
      return "职员信息";
    },
  },
  data() {
    return {
      loading: false,
      textForm: {},
      requestParam: {}
    };
  },
  mounted() {
    this.init()
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    init() {
      this.loading = true
      this.$api.dataReport.userManageGetUserInfo(this.userId).then(res => {
        this.textForm = res.data
      }).finally(res => {
        this.loading = false
      })
    }
  },
};
</script>

<style lang="stylus" scoped>
>>> .el-form-item{
  margin-bottom: 10px
}
</style>
